var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.getPholderClass, on: { click: _vm.selectCategory } },
    [
      _c("div", { staticClass: "m-0 w-100" }, [
        _c("div", { staticClass: "qheadding qbold" }, [
          _c(
            "div",
            { class: _vm.siteImageClass(_vm.isIcon) },
            [
              _c("q-icon", {
                staticClass: "qicon",
                attrs: {
                  allowSelfUpdate: false,
                  width: "20px",
                  height: "20px",
                  name: _vm.getSiteImageName,
                  pack: _vm.getSiteImagePack
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("span", { staticClass: "category-label" }, [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t(_vm.getSiteLabel)) +
                "\n          "
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "m-0 w-100" }, [
        _c(
          "div",
          { staticClass: "qbody" },
          [
            _c("div", { staticClass: "m-0 centered" }, [
              _c("div", { staticClass: "p-0" }, [
                _c("p", [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t(_vm.site.description)) +
                      "\n          "
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("input-button", {
              attrs: {
                variant: "standardInput",
                btnStyle: "ok-style",
                smaller: "",
                hollow: "",
                centered: "",
                inputPlaceholder: _vm.getButtonLabel
              }
            })
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-825b915c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-825b915c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/service/campaignManager/CategoryPholder.vue
// module id = null
// module chunks = 